<template>
  <div class="col-12 component-survey-stat-wrapper">
    <div class="component-survey-stat w-100">
      <div class="inner">
        <KitProgressBar :total="stat.totalQuestions" :count="stat.completedQuestions" :showCoach="showCoach" :title="stat.surveyType" :surveyType="stat.surveyType" :buttonTextOverride="buttonText" :kitId="kitId" />
      </div>
    </div>
  </div>
</template>

<script>
import apiStringMappings from '@/mixins/apiStringMapping'
import KitProgressBar from '@/components/elements/KitProgressBar'

export default {
  name: 'SurveyStat',
  props: ['stat', 'kitId', 'showCoach'],
  mixins: [apiStringMappings],
  components: {
    KitProgressBar
  },
  computed: {
    formattedType: function () {
      return this.sampleToString(this.stat.surveyType)
    },
    percent: function () {
      return Number(this.stat.completedQuestions) / Number(this.stat.totalQuestions) * 100
    },
    className: function () {
      return (this.percent === 100) ? 'progress-bar bg-success' : 'progress-bar bg-info'
    },
    buttonText: function () {
      let text = 'Continue'
      if (this.percent >= 100) { text = 'View' } else
      if (this.percemt === 0) { text = 'Start' }
      return text
    },
    readMoreLink: function () {
      const slug = this.sampleToSlug(this.stat.surveyType)
      return 'surveys/' + slug + '/' + this.kitId
    }
  }
}
</script>

<style scoped>
.nav-link {
  padding: 0.5rem 0;
}
</style>
 


// WEBPACK FOOTER //
// src/components/elements/SurveyStat.vue